import { Injectable, inject } from '@angular/core';
import { HttpApiResponse, HttpApiService } from '@core/http';
import { MixinBaseClass } from '@core/mixins';
import { VersionsApiMixin } from '@core/referentials';
import { WizardApiPath } from '@wizard/constants';
import { WizardBasket, WizardBasketList } from '@wizard/models';
import { BasicWizardBasketStatusType } from '@wizard/types';
import { Observable } from 'rxjs';

const WizardBasketApiRoute = `${WizardApiPath}/baskets`;

@Injectable({ providedIn: 'root' })
export class WizardApiService extends VersionsApiMixin(MixinBaseClass) {

  /** @Inject */
  private readonly apiService = inject(HttpApiService);

  constructor() {
    super();
  }

  saveBasket(basket: WizardBasket): Observable<HttpApiResponse<WizardBasket>> {
    return this.apiService.send<WizardBasket, HttpApiResponse<WizardBasket>>(WizardBasketApiRoute, basket);
  }

  getBasketList(): Observable<HttpApiResponse<WizardBasketList>> {
    return this.apiService.get<HttpApiResponse<WizardBasketList>>(WizardBasketApiRoute);
  }

  getBasket(basket: WizardBasket): Observable<HttpApiResponse<WizardBasket>> {
    return this.apiService.get<HttpApiResponse<WizardBasket>>(`${WizardBasketApiRoute}/${basket.id}`);
  }

  deleteBasket(basket: WizardBasket): Observable<HttpApiResponse<boolean>> {
    return this.apiService.delete(`${WizardBasketApiRoute}`, basket.id);
  }

  updateBasketStatus(basket: WizardBasket, newStatus: BasicWizardBasketStatusType): Observable<HttpApiResponse<boolean>> {
    return this.apiService.update<{ status: BasicWizardBasketStatusType; }, HttpApiResponse<boolean>>(
      `${WizardBasketApiRoute}/${basket.id}/update`,
      { status: newStatus }
    );
  }
}
